import { render, staticRenderFns } from "./vAccCapacitacion.vue?vue&type=template&id=000d8dae&scoped=true&"
import script from "./vAccCapacitacion.vue?vue&type=script&lang=js&"
export * from "./vAccCapacitacion.vue?vue&type=script&lang=js&"
import style0 from "./vAccCapacitacion.vue?vue&type=style&index=0&id=000d8dae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000d8dae",
  null
  
)

export default component.exports